import type { Locale } from '../i18n/LocaleContext'

const STORAGE_KEY = 'preferred-locale'

export function getPreferredLocale(): Locale {
  // Check localStorage first
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'hu' || stored === 'ro') return stored

  // Detect from browser language
  const lang = navigator.language.toLowerCase()
  if (lang.startsWith('hu')) return 'hu'
  return 'ro'
}

export function setPreferredLocale(locale: Locale) {
  localStorage.setItem(STORAGE_KEY, locale)
}

// Map locale-specific route slugs to each other
const routeMap: Record<string, Record<Locale, string>> = {
  rolunk: { hu: 'rolunk', ro: 'despre' },
  despre: { hu: 'rolunk', ro: 'despre' },
  tevekenysegek: { hu: 'tevekenysegek', ro: 'activitati' },
  activitati: { hu: 'tevekenysegek', ro: 'activitati' },
  taborok: { hu: 'taborok', ro: 'tabere' },
  tabere: { hu: 'taborok', ro: 'tabere' },
  gyik: { hu: 'gyik', ro: 'intrebari-frecvente' },
  'intrebari-frecvente': { hu: 'gyik', ro: 'intrebari-frecvente' },
  kapcsolat: { hu: 'kapcsolat', ro: 'contact' },
  contact: { hu: 'kapcsolat', ro: 'contact' },
  feltetelek: { hu: 'feltetelek', ro: 'termeni' },
  termeni: { hu: 'feltetelek', ro: 'termeni' },
  adatvedelem: { hu: 'adatvedelem', ro: 'confidentialitate' },
  confidentialitate: { hu: 'adatvedelem', ro: 'confidentialitate' },
  'cookie-szabalyzat': { hu: 'cookie-szabalyzat', ro: 'politica-cookies' },
  'politica-cookies': { hu: 'cookie-szabalyzat', ro: 'politica-cookies' },
  beiratkozas: { hu: 'beiratkozas', ro: 'inscriere' },
  inscriere: { hu: 'beiratkozas', ro: 'inscriere' },
  'fizetes-eredmeny': { hu: 'fizetes-eredmeny', ro: 'rezultat-plata' },
  'rezultat-plata': { hu: 'fizetes-eredmeny', ro: 'rezultat-plata' },
}

export function getLocalizedPath(currentPath: string, targetLocale: Locale): string {
  // Extract the section slug from the current path (e.g., /hu/rolunk -> rolunk)
  const parts = currentPath.split('/').filter(Boolean)
  const slug = parts[1] || '' // After the locale prefix

  if (!slug) return `/${targetLocale}`

  const mapped = routeMap[slug]
  if (mapped) {
    // Preserve any trailing segments (e.g. a camp slug in /hu/taborok/<id>),
    // which are language-neutral and carry across locales unchanged.
    const rest = parts.slice(2).join('/')
    return `/${targetLocale}/${mapped[targetLocale]}` + (rest ? `/${rest}` : '')
  }

  return `/${targetLocale}`
}
